import React from "react";


export default ({ cashout }) => {
  return (
    <div className="mt-2">
      <div className="p-2">
        <pre className="text-xs bg-gray-800 text-gray-100 rounded p-2">{JSON.stringify(cashout, null, 2)}</pre>
      </div>
    </div>
  );
};
